<template>
  <adivare-input
    :outer-class="outerClass"
    :input-class="inputClass"
    :legend-class="legendClass"
    :placeholder="fieldLabel"
    :field-label="fieldLabel"
    :label-class="labelClass"
    :property-name="propertyName"
    form-type="text"
    ref="typeahead-input"
    v-model="fieldValue"
    @keydown.down="down"
    @keydown.up="up"
    @keydown.enter="onHit(current)"
    @keydown.esc="reset"
    @focus="inputFocused = true"
    @blur="inputFocused = false"
    @input="process"
  >
    <div class="relative">
      <ul
        @mouseover="hover = true"
        @mouseleave="hover = false"
        class="typeahead-results"
        v-show="hasResults && (inputFocused || hover)"
      >
        <li
          v-for="(result, index) in results"
          :class="['typeahead-result', { active: current === index }]"
          @click="onHit(index)"
          @mousemove="setActive(index)"
        >
          {{ result[displayProperty] }}
        </li>
      </ul>
    </div>
  </adivare-input>
</template>

<script>
import typeahead from "../../../../components/form/loose-js/typeahead";
import ApiClient from "../../../../axios-client";
import formMixin from "../../../mixins/form-mixin";
import defaultFormValidatorMixin from "../../../mixins/default-form-validator-mixin";

let callback = async function(query){
  return await ApiClient
    .callTypeahead(query)
    .then(res => res.data);
};

export default {
  extends: typeahead,
  mixins: [
    formMixin,
    defaultFormValidatorMixin,
  ],
  name: 'adivare-generic-cancellation-typeahead',
  props: {
    outerClass: {
      type: String,
      required: false,
      default: 'form-field',
    },
    class: {
      type: String,
      required: false,
      default: '',
    },
    displayProperty: {
      type: [String, Number],
      required: false,
      default: 'companyName',
    },
  },
  data() {
    return {
      inputFocused: false,
      minChars: 2,
      hover: false,
      searchCallback: callback,
    };
  },
  computed: {
    fieldValue: {
      get() {
        return this.query;
      },
      set(value) {
        this.query = value;
        this.validateField(value);
        this.$store.dispatch('updateFormField', {
          name: this.propertyName,
          value: this.query,
        });
      },
    },
  },
  methods: {
    onHit(index) {
      if (0 === this.results.length) return;
      const result = this.results[(-1 === index) ? 0 : index];
      let form = document.querySelector('[name=search]');
      form['search[company]'].value = result['companyName'];
      form['search[cancellationId]'].value = result['id'];
      form['search[companyName]'].value = result['companyName'];
      form.submit();
    },
  }
}
</script>
